import React from 'react'
import ReactDOM from 'react-dom'
import { AppContainer } from 'react-hot-loader'
import App from './App.js'

const rootEl = document.getElementById('mount')
ReactDOM.render(
  <AppContainer>
    <App />
  </AppContainer>,
  rootEl,
)

if (module.hot) {
  module.hot.accept('./App.js', () => {
    // If you use Webpack 2 in ES modules mode, you can
    // use <App /> here rather than require() a <NextApp />.
    const NextApp = require('./App.js').default
    ReactDOM.render(
      <AppContainer>
        <NextApp />
      </AppContainer>,
      rootEl,
    )
  })
}



// WEBPACK FOOTER //
// ./src/index.js